(function () {
  document.addEventListener("scroll", function () {
    document.documentElement.style.height = window.innerHeight + "px";
  });
  // 菜单栏选项卡功能
  class MenuTabBox extends HTMLElement {
    constructor() {
      // 继承父对象上的函数
      super();

      this.all_tab = this.querySelectorAll(".menu-collections-list-item");
      this.all_content = this.querySelectorAll(".menu-products-block-list");

      this.timer = null;

      this.all_tab.forEach((tab, index) => {
        tab.addEventListener("mouseover", () => {
          this.all_tab_hide();
          tab.classList.add("active");

          this.all_content_hide();
          this.all_content[index].classList.add("active");
        });
      });
    }
    all_tab_hide() {
      this.all_tab.forEach((tab) => {
        if (tab.classList.contains("active")) {
          tab.classList.remove("active");
        }
      });
    }
    all_content_hide() {
      this.all_content.forEach((content) => {
        if (content.classList.contains("active")) {
          content.classList.remove("active");
        }
      });
    }
  }
  window.customElements.define("menu-tab-box", MenuTabBox);

  // 手机端菜单栏幻灯片部分
  class MobileMenuSlide extends HTMLElement {
    constructor() {
      super();
      new Swiper(this.querySelector(".swiper"), {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 6,
      });
    }
  }
  window.customElements.define("mobile-menu-slide", MobileMenuSlide);

  // <countdown-box> CountdownBox.js
  class CountdownBox extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.CountDownStart(this.beginTime, this.endTime);
    }
    getLocalTime(i) {
      if (typeof i !== "number") return;
      var d = new Date();
      //得到1970年一月一日到现在的秒数
      var len = d.getTime();
      //本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
      var offset = d.getTimezoneOffset() * 60000;
      //得到现在的格林尼治时间
      var utcTime = len + offset;
      return new Date(utcTime + 3600000 * i);
    }
    get_compare_time(beginTime, endTime) {
      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      // 获取倒计时开始时间的时间戳（需要传入世界协调时）
      const countStart = Date.parse(beginTime);
      // 获取倒计时结束时间的时间戳（需要传入世界协调时）
      const countEnd = Date.parse(endTime);
      // 获取当前时间的时间戳 （世界协调时）
      const now = this.getLocalTime(0).getTime();
      //现在距离活动开始或结束时间的时间
      let startDistance = countStart - now;
      let endDistance = countEnd - now;
      /*
                @ nowType:
                0: "活动开始前"
                1: "活动进行中"
                2: "活动已结束"
            */

      let activityType = 0;
      let days, hours, minutes, seconds;

      if (startDistance < 0 && endDistance > 0) {
        // 活动进行中
        activityType = 1;
        days = -Math.floor(endDistance / day);
        hours = -Math.floor((endDistance % day) / hour);
        minutes = -Math.floor((endDistance % hour) / minute);
        seconds = -Math.floor((endDistance % minute) / second);
      } else if (endDistance <= 0 && startDistance < 0) {
        // 活动结束
        activityType = 2;
      } else {
        // 活动未开始
        activityType = 0;
        days = -Math.floor(startDistance / day);
        hours = -Math.floor((startDistance % day) / hour);
        minutes = -Math.floor((startDistance % hour) / minute);
        seconds = -Math.floor((startDistance % minute) / second);
      }

      return {
        activityType,
        startDistance,
        endDistance,
        DD: -days,
        HH: -hours,
        MM: -minutes,
        SS: -seconds,
      };
    }
    CountDownStart(beginTime, endTime) {
      let x = setInterval(() => {
        let time_obj = this.get_compare_time(beginTime, endTime);
        if (time_obj.activityType !== 1) {
          //活动未开始或已结束
          this.style.display = "none";
          clearInterval(x);
          return;
        }
        this.querySelector(".days").innerText = time_obj.DD;
        this.querySelector(".hours").innerText =
          time_obj.HH >= 10 ? time_obj.HH : "0" + time_obj.HH;
        this.querySelector(".minutes").innerText =
          time_obj.MM >= 10 ? time_obj.MM : "0" + time_obj.MM;
        this.querySelector(".seconds").innerText =
          time_obj.SS >= 10 ? time_obj.SS : "0" + time_obj.SS;
      }, 500);
    }
    get beginTime() {
      if (this.hasAttribute("countdown_start_time")) {
        return this.getAttribute("countdown_start_time");
      } else {
        return "2000/01/01 05:00:00";
      }
    }
    get endTime() {
      if (this.hasAttribute("countdown_end_time")) {
        return this.getAttribute("countdown_end_time");
      } else {
        return "2000/01/01 00:00:00";
      }
    }
  }
  window.customElements.define("countdown-box", CountdownBox);

  // 下拉抽屉
  var DescriptionDrawer = class extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.querySelector(".more_btn span").onclick = () => {
        if (this.hasAttribute("open")) {
          this.removeAttribute("open");
        } else {
          this.setAttribute("open", "");
        }
      };
    }
  };
  window.customElements.define("description-drawer", DescriptionDrawer);

  // 视频评论
  var Video_review__content = class extends HTMLElement {
    constructor() {
      super();
      new Swiper(this.querySelector(".swiper"), {
        noSwiping: true,
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // autoHeight: true,
        breakpoints: {
          500: {
            slidesPerView: 2.1,
            slidesPerGroup: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3.1,
            slidesPerGroup: 3,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3.2,
            slidesPerGroup: 3,
            spaceBetween: 30,
          },
        },
        // pagination: {
        //   el: this.querySelector('.swiper-pagination'),
        //   type: "progressbar",
        // },
        // navigation: {
        //   nextEl: this.querySelector('.next'),
        //   prevEl: this.querySelector('.prev'),
        // },
      });
    }
  };
  window.customElements.define("video-review--content", Video_review__content);

  class PullDownDrawer extends HTMLElement {
    constructor() {
      // 继承父对象上的函数
      super();
      if (this.hasAttribute("open")) {
        this.open = true;
      } else {
        this.open = false;
      }
      this.querySelector(".footer__item_title").addEventListener(
        "click",
        (e) => {
          if (this.open) {
            this.open = false;
          } else {
            this.open = true;
          }
        },
        false
      );
      this.addEventListener(
        "click",
        (e) => {
          if (
            e.target.classList.contains("arrow_icon") ||
            e.target.classList.contains("footer_arrow")
          ) {
            if (this.open) {
              this.open = false;
            } else {
              this.open = true;
            }
          }
        },
        false
      );
      if (this.classList.contains("footer__nav_list")) {
        let height = Math.ceil(this.clientHeight / 10);
        this.style.gridRow = `span ${~~height}`;
      }
    }
    get open() {
      if (this.hasAttribute("open")) {
        return true;
      } else {
        return false;
      }
    }
    set open(value) {
      if (value) {
        this.setAttribute("open", "");
      } else {
        this.removeAttribute("open");
      }
    }
  }
  window.customElements.define("pull-down-drawer", PullDownDrawer);

  class FooterPoliceDrawer extends HTMLElement {
    constructor() {
      // 继承父对象上的函数
      super();
      if (this.hasAttribute("open")) {
        this.open = true;
      } else {
        this.open = false;
      }
      this.addEventListener(
        "click",
        (e) => {
          if (this.open) {
            this.open = false;
          } else {
            this.open = true;
          }
        },
        false
      );
    }
    get open() {
      if (this.hasAttribute("open")) {
        return true;
      } else {
        return false;
      }
    }
    set open(value) {
      if (value) {
        this.setAttribute("open", "");
      } else {
        this.removeAttribute("open");
      }
    }
  }
  window.customElements.define("footer-police-drawer", FooterPoliceDrawer);

  class VideoPopupWindow extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.video_link = this.getAttribute("link");
      this.provider = this.getAttribute("provider");
      this.addEventListener(
        "click",
        (e) => {
          if (e.target.classList.contains("popup-video-target")) {
            return;
          }
          this.close();
        },
        false
      );
    }
    loadVideo() {
      let iframe;
      if (this.provider == "youtube") {
        iframe = `<iframe src="${this.video_link}" allow="autoplay; encrypted-media" allowfullscreen="allowfullscreen"></iframe>`;
      } else if (this.provider == "vimeo") {
        iframe = `<iframe src="${this.video_link}" allow="autoplay; encrypted-media;" allowfullscreen="allowfullscreen"></iframe>`;
      } else {
        iframe = `<video class="popup-video-target" src="${this.video_link}" controls playsinline></video>`;
      }
      let video_dom = `${iframe}`;
      this.innerHTML = iframe;
      let close_dom = document.createElement("div");
      close_dom.className = "close_button";
      close_dom.innerHTML = `
        <svg focusable="false" viewBox="0 0 14 14">
          <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" fill="none"></path>
        </svg>
        `;
      this.appendChild(close_dom);
      this.loading = true;
    }
    play() {
      if (this.provider === "youtube") {
        this.querySelector("iframe").contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "playVideo", args: "" }),
          "*"
        );
      } else if (this.provider === "vimeo") {
        this.querySelector("iframe").contentWindow.postMessage(
          JSON.stringify({ method: "play" }),
          "*"
        );
      } else {
        this.querySelector("video").play();
      }
    }
    pause() {
      if (this.provider === "youtube") {
        this.querySelector("iframe").contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "pauseVideo", args: "" }),
          "*"
        );
      } else if (this.provider === "vimeo") {
        this.querySelector("iframe").contentWindow.postMessage(
          JSON.stringify({ method: "pause" }),
          "*"
        );
      } else {
        this.querySelector("video").pause();
      }
    }
    open() {
      if (!this.loading) {
        this.loadVideo();
      }
      this.type = "open";
      this.play();
    }
    close() {
      this.type = "close";
      this.pause();
    }
    get type() {
      if (this.hasAttribute("open")) {
        return "open";
      } else {
        return "close";
      }
    }
    set type(value) {
      if (value == "open") {
        this.setAttribute("open", "");
      } else {
        this.removeAttribute("open");
      }
    }
  }
  window.customElements.define("video-popup-window", VideoPopupWindow);

  class VideoPopupBox extends HTMLElement {
    constructor() {
      super();
      let video_popup_dom;
      if (this.hasAttribute("video-popup-class")) {
        video_popup_dom = document.querySelector(
          `.${this.getAttribute("video-popup-class")}`
        );
      } else {
        video_popup_dom = this.querySelector("video-popup-window");
      }
      this.querySelector(".video-wrapper__play-button").addEventListener(
        "click",
        () => {
          video_popup_dom.open();
        },
        false
      );
    }
  }
  window.customElements.define("video-popup-box", VideoPopupBox);

  class SwiperTab extends HTMLElement {
    constructor() {
      super();
      this.line = this.querySelector(".swiper_tab__line");
      this.init();
    }
    init() {
      this.head_swiper = new Swiper(this.querySelector(".swiper_tab__list"), {
        slidesPerView: "auto",
        spaceBetween: 10,
        allowTouchMove: false,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceAfter: 30,
        breakpoints: {
          550: {
            spaceBetween: 10,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
          1000: {
            spaceBetween: 30,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
        },
      });
      this.body_swiper = new Swiper(
        this.querySelector(".swiper_tab__content"),
        {
          spaceBetween: 12,
          autoHeight: true,
          on: {
            slideChangeTransitionEnd: (swiper) => {
              this.head_swiper.slideTo(swiper.activeIndex);
              this.querySelectorAll(".swiper_tab__item").forEach(
                (item, index) => {
                  if (item.classList.contains("active")) {
                    item.classList.remove("active");
                  }
                }
              );
              this.querySelectorAll(".swiper_tab__item")[
                swiper.activeIndex
              ].classList.add("active");
              this.line.style.width =
                this.querySelectorAll(".swiper_tab__item")[swiper.activeIndex]
                  .clientWidth + "px";
              this.line.style.transform =
                "translateX(" +
                (this.querySelectorAll(".swiper_tab__item")[swiper.activeIndex]
                  .offsetLeft +
                  this.head_swiper.translate) +
                "px)";
            },
          },
        }
      );

      this.line.style.width =
        this.querySelectorAll(".swiper_tab__item")[0].clientWidth + "px";
      this.line.style.transform =
        "translateX(" +
        (this.querySelectorAll(".swiper_tab__item")[0].offsetLeft +
          this.head_swiper.translate) +
        "px)";

      // 为 .swiper_tab__item 添加点击事件
      this.querySelectorAll(".swiper_tab__item").forEach((item) => {
        item.onclick = () => {
          this.head_swiper.slideTo(item.getAttribute("data-index") - 0);
          this.body_swiper.slideTo(item.getAttribute("data-index") - 0);
          if (item.classList.contains("active")) {
            return;
          }
          this.querySelectorAll(".swiper_tab__item").forEach((item) => {
            if (item.classList.contains("active")) {
              item.classList.remove("active");
            }
          });
          item.classList.add("active");

          this.line.style.width = item.clientWidth + "px";
          let slideLeft = item.offsetLeft + this.head_swiper.translate;
          this.line.style.transform = "translateX(" + slideLeft + "px)";
        };
      });

      window.addEventListener("resize", () => {
        let item = this.querySelector(".swiper_tab__list .active");
        this.line.style.width = item.clientWidth + "px";
        let slideLeft = item.offsetLeft + this.head_swiper.translate;
        this.line.style.transform = "translateX(" + slideLeft + "px)";
      });
    }
  }
  window.customElements.define("swiper-tab", SwiperTab);

  class HeaderNoticeBoard extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.open = true;
    }
    init() {
      this.querySelector(".close_icon_button").addEventListener("click", () => {
        this.open = false;
      });
    }
    get open() {
      if (this.hasAttribute("open")) {
        return true;
      } else {
        return false;
      }
    }
    set open(value) {
      if (value) {
        this.setAttribute("open", "");
      } else {
        if (this.hasAttribute("open")) {
          this.removeAttribute("open");
        }
      }
    }
  }
  window.customElements.define("header-notice-board", HeaderNoticeBoard);

  class anchorPointBox extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.swiper = new Swiper(this.querySelector(".anchor_point_swiper"), {
        slidesPerView: "auto",
        spaceBetween: 22,
        centeredSlides: false,
        centeredSlidesBounds: false,
      });
      let slides = this.querySelectorAll(".anchor_point_swiper .swiper-slide");
      if (slides.length >= 1) {
        slides.forEach((item) => {
          item.addEventListener("click", (event) => {
            event.preventDefault();
            let targetElement = document.querySelector(
              `#${item.getAttribute("scroll-id")}`
            );
            if (!targetElement) {
              return;
            }
            slides.forEach((i) => {
              i.classList.remove("active");
            });
            this.swiper.slideTo(item.getAttribute("slide-index") - 0);
            // slides.forEach((i)=>{
            //     document.querySelector(`#${i.getAttribute('scroll-id')}`).classList.remove('anchor_point__active')
            // })
            targetElement.classList.add("anchor_point__active");
            item.classList.add("active");
            const targetOffset =
              targetElement.getBoundingClientRect().top +
              window.pageYOffset -
              parseFloat(getComputedStyle(targetElement).paddingTop);
            targetElement.classList.remove("anchor_point__active");
            // targetElement.scrollIntoView({behavior:"smooth", block: "start", inline: "nearest", offset: targetOffset});
            window.scrollTo({ top: targetOffset, behavior: "smooth" });
          });
        });
        // 监听滚动
        let lastScrollTop = 0;
        window.addEventListener("scroll", (e) => {
          const currentScrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          const isScrollingDown = currentScrollTop > lastScrollTop;
          if (isScrollingDown) {
            if (window.scrollY >= 120) {
              // 向下滚动，隐藏菜单栏
              document.querySelector(".phone_anchor_point").style.top =
                "calc((var(--header-height, 0px)) * var(--enable-sticky-header) + var(--announcement-bar-height, 0px) * var(--enable-sticky-announcement-bar))";
            }
          } else {
            // 向上滚动，不隐藏菜单栏
            if (window.scrollY < 120) {
              document.querySelector(".phone_anchor_point").style.top = "-100%";
            }
          }

          lastScrollTop = currentScrollTop;
        });
      }
    }
  }
  window.customElements.define("anchor-point-box", anchorPointBox);

  // 产品页面协议弹窗
  class IntroductionServicePopup extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", () => {
        this.open = false;
      });
      this.querySelector(".Introduction_service_popup_box").addEventListener(
        "click",
        (e) => {
          e.stopPropagation();
        }
      );
      this.querySelector(
        ".Introduction_service_popup__close button"
      ).addEventListener("click", (e) => {
        e.stopPropagation();
        this.open = false;
      });
    }
    get open() {
      if (this.hasAttribute("open")) {
        return true;
      } else {
        return false;
      }
    }
    set open(value) {
      if (value) {
        this.setAttribute("open", "");
      } else {
        if (this.hasAttribute("open")) {
          this.removeAttribute("open");
        }
      }
    }
  }
  window.customElements.define(
    "introduction-service-popup",
    IntroductionServicePopup
  );

  class ProductActiveAddCart extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.product_id = this.getAttribute("product-id") - 0;
      this.variant_id = this.getAttribute("variant-id") - 0;
      this.change_type = true;
    }
    init() {
      this.loading();
      this.addEventListener(
        "click",
        (event) => {
          if (this.classList.contains("sold-out")) {
            return;
          }
          event.stopPropagation();
          if (this.change_type) {
            return;
          }
          if (this.active) {
            this.remove_to_cart();
          } else {
            this.add_to_cart();
          }
        },
        false
      );
      if (this.querySelector(".guess_you_like__product_content .detail_link")) {
        this.querySelector(
          ".guess_you_like__product_content .detail_link"
        ).addEventListener(
          "click",
          (event) => {
            event.stopPropagation();
          },
          false
        );
      }
      // 购物车更新
      document.addEventListener("cart:updated", (event) => {
        var cart = event.detail.cart;
        let items = cart.items;
        this.active = false;
        items.forEach((item) => {
          if (item.product_id == this.product_id) {
            if (this.variant_id) {
              if (this.variant_id == item.variant_id) {
                this.active = true;
              }
            } else {
              this.active = true;
            }
          }
        });
      });
      if (
        this.querySelector(".open_popup") &&
        this.querySelector("giraffe-tools-care-popup")
      ) {
        this.querySelector(".open_popup").addEventListener("click", (event) => {
          event.stopPropagation();
          this.querySelector("giraffe-tools-care-popup").show();
        });
      }
      if (!!this.querySelector(".variant_select_box select")) {
        this.querySelector(".variant_select_box select").addEventListener(
          "click",
          (event) => {
            event.stopPropagation();
          }
        );
        this.querySelector(".variant_select_box select").addEventListener(
          "change",
          (event) => {
            this.variant_id = event.target.value - 0;
            this.change_type = true;
            this.active = false;
            this.loading();
          }
        );
      }
    }
    loading() {
      this.get_cart()
        .then((res) => {
          let items = res.items;
          console.log(items);
          items.forEach((item) => {
            if (item.product_id == this.product_id) {
              if (this.variant_id == item.variant_id) {
                this.active = true;
              }
            }
          });
          this.change_type = false;
        })
        .catch((err) => {
          console.log(err);
          this.change_type = false;
        });
    }
    get_cart() {
      return new Promise((resolve, reject) => {
        // 获取购物车数据
        fetch("/cart.js")
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              reject("获取购物车err");
            }
          })
          .then((cartData) => {
            resolve(cartData);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
    async cart_updata() {
      const response = await fetch(
        `${window.themeVariables.routes.cartUrl}/update.js`,
        {
          body: JSON.stringify({ note: this.value }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const cartContent = await response.json();
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent,
          },
        })
      );
    }
    add_to_cart() {
      this.change_type = true;
      // 发起 AJAX 请求，将产品添加到购物车
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          quantity: 1,
          id: this.variant_id - 0,
        }),
      })
        .then((response) => {
          if (response.ok) {
            // 添加成功
            this.get_cart()
              .then((res) => {
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: false,
                    detail: {
                      cart: res,
                      openMiniCart: false,
                    },
                  })
                );
                this.cart_updata();
                this.active = true;
                this.change_type = false;
              })
              .catch((err) => {
                console.log(err);
                this.change_type = false;
              });
          } else {
            // 添加失败
            console.error("产品添加到购物车失败");
            this.change_type = false;
          }
        })
        .catch((error) => {
          console.error("发生错误", error);
          this.change_type = false;
        });
    }
    remove_to_cart() {
      this.change_type = true;
      console.log(this.variant_id);
      // 发起 AJAX 请求，从购物车中删除产品
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {
            [this.variant_id]: 0,
          },
          // quantity: 0,
          // id: this.variant_id
        }),
      })
        .then((response) => {
          console.log(response);
          if (response.ok) {
            // 删除成功
            this.get_cart()
              .then((res) => {
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: false,
                    detail: {
                      cart: res,
                      openMiniCart: false,
                    },
                  })
                );
                this.cart_updata();
                this.active = false;
                this.change_type = false;
              })
              .catch((err) => {
                console.log(err);
                this.change_type = false;
              });
          } else {
            // 删除失败
            console.error("产品从购物车中删除失败");
            this.change_type = false;
          }
        })
        .catch((error) => {
          console.error("发生错误", error);
          this.change_type = false;
        });
    }
    get active() {
      if (this.hasAttribute("active")) {
        return true;
      } else {
        return false;
      }
    }
    set active(value) {
      if (value) {
        this.setAttribute("active", "");
      } else {
        if (this.hasAttribute("active")) {
          this.removeAttribute("active");
        }
      }
    }
    get change_type() {
      if (this.hasAttribute("loading")) {
        return true;
      } else {
        return false;
      }
    }
    set change_type(value) {
      if (value) {
        this.setAttribute("loading", "");
      } else {
        if (this.hasAttribute("loading")) {
          this.removeAttribute("loading");
        }
      }
    }
  }
  window.customElements.define("product-active-add-cart", ProductActiveAddCart);

  class AddToCartButton extends HTMLElement {
    constructor() {
      super();
      this.bundle_products = this.querySelectorAll(".bundle_product_pro");
      this.products = [];
      this.bundle_products_arr = [];
      this.bundle_products.forEach((item, index) => {
        let product_id = item.getAttribute("product_variant_id");
        this.products.push({
          quantity: 1,
          id: product_id,
        });
        let bundle_add_cart_btn = document.getElementById(
          item.getAttribute("product-popup-box")
        );
        this.bundle_products_arr.push(bundle_add_cart_btn);
        bundle_add_cart_btn.querySelector(
          ".product-add_to_cart .button-levels-1"
        ).onclick = (e) => {
          this.add_to_cart();
          bundle_add_cart_btn.style.display = "none";
        };
        item.addEventListener(
          "click",
          () => {
            let popup_dom = document.getElementById(
              item.getAttribute("product-popup-box")
            );
            popup_dom.style.display = "flex";
            popup_dom.onclick = () => {
              popup_dom.style.display = "none";
            };
            popup_dom.querySelector(".close-popup-icon").onclick = () => {
              popup_dom.style.display = "none";
            };
            popup_dom.querySelector(".product-details-popup-box").onclick = (
              e
            ) => {
              e.stopPropagation();
            };
          },
          false
        );
        bundle_add_cart_btn.querySelector(".next-product").onclick = (e) => {
          e.stopPropagation();
          this.change_product(index + 1);
        };
        bundle_add_cart_btn.querySelector(".prev-product").onclick = (e) => {
          e.stopPropagation();
          this.change_product(index - 1);
        };
      });
      this.querySelector(".bundle_product_btn button").onclick = () => {
        this.add_to_cart();
      };
    }
    change_product(index) {
      this.bundle_products_arr.forEach((item, index) => {
        item.style.display = "none";
      });
      this.bundle_products_arr[index].style.display = "flex";
      this.bundle_products_arr[index].onclick = () => {
        this.bundle_products_arr[index].style.display = "none";
      };
      this.bundle_products_arr[index].querySelector(
        ".close-popup-icon"
      ).onclick = () => {
        this.bundle_products_arr[index].style.display = "none";
      };
      this.bundle_products_arr[index].querySelector(
        ".product-details-popup-box"
      ).onclick = (e) => {
        e.stopPropagation();
      };
    }
    add_to_cart() {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: this.products }),
      })
        .then((response) => {
          if (response.ok) {
            // 添加成功
            this.get_cart()
              .then((res) => {
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: false,
                    detail: {
                      cart: res,
                      openMiniCart: true,
                    },
                  })
                );
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            console.error("产品添加到购物车失败");
          }
        })
        .catch((error) => {
          console.error("加入购物车失败:", error);
        });
    }
    get_cart() {
      return new Promise((resolve, reject) => {
        // 获取购物车数据
        fetch("/cart.js")
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              reject("获取购物车err");
            }
          })
          .then((cartData) => {
            resolve(cartData);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  }
  window.customElements.define("add-to-cart-button", AddToCartButton);

    // 锚点组件
    class AnchorPointTab extends HTMLElement {
        constructor() {
            super();
            this.swiper = new Swiper(this.querySelector('.swiper'), {
                slidesPerView: "auto",
                slidesPerGroup: 1,
                centeredSlides: true,
                centeredSlidesBounds: true,
            });

            let list = this.querySelectorAll('.point_item')
            let wrapperWidth = 0;
            list.forEach(slide => {
                wrapperWidth += slide.clientWidth;
            });
            this.querySelector('.swiper').style.maxWidth = wrapperWidth + "px"

            const isElementInViewport = (element,endElement) => {
                const rect = element.getBoundingClientRect();
                if(endElement){
                    const endRect = endElement.getBoundingClientRect();
                    return (
                        rect.top <= 60 &&
                        endRect.bottom >= 60
                    );
                }else{
                    return (
                        rect.top >= 59 &&
                        rect.top <= window.innerHeight - 60
                    )
                }
            };
            const handleScroll = () => {
                this._type = false
                list.forEach((item) => {
                    if (!this._type) {
                        if (item.hasAttribute("dom_id")) {
                            let ele_id = item.getAttribute('dom_id')
                            let startElement = document.getElementById(ele_id);
                           
                            let end_ele_id = item.getAttribute('end_dom_id');
                            let endElement=null;
                            if(end_ele_id){
                                endElement= document.getElementById(end_ele_id);
                            }
                            if (isElementInViewport(startElement,endElement)) {
                                this._type = true
                                this.swiper.slideTo(item.getAttribute('data-index') - 0);
                                list.forEach((ele) => {
                                    if (ele.classList.contains('active')) {
                                        ele.classList.remove('active');
                                    }
                                });
                                item.classList.add('active');
                            }
                        }
                    }
                });
            };

            // Add scroll event listener
            window.addEventListener('scroll', handleScroll);
            document.body.addEventListener('scroll', handleScroll);

            this.addEventListener('disconnect', () => {
                window.removeEventListener('scroll', handleScroll);
                document.body.removeEventListener('scroll', handleScroll);
            });
            this.timer = null
            list.forEach((item) => {
                item.onclick = () => {
                    clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        this.swiper.slideTo(item.getAttribute('data-index') - 0);
                        list.forEach((ele) => {
                            if (ele.classList.contains('active')) {
                                ele.classList.remove('active')
                            }
                        })
                        item.classList.add('active')
                    },600)
                    if (item.hasAttribute("dom_id")) {
                        let ele_id = item.getAttribute('dom_id')
                        let ele_top = document.getElementById(ele_id).offsetTop
                        document.body.scrollTo({
                            top: ele_top - 60,
                            behavior: "smooth"
                        });
                    }
                }
            })

        }
    }
    window.customElements.define('anchor-point-tab', AnchorPointTab);

  //
  class ShopifyEmailFrom extends HTMLElement {
    constructor() {
      super();
      this.querySelector(".newsletter__button").onclick = () => {
        if (this.querySelector(".newsletter__button").innerHTML == "SUCCESS") {
          return;
        }
        let inputvalue = this.querySelector(".newsletter__input").value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(inputvalue)) {
          alert("Incorrect email format");
          return;
        }
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "email_subscribe",
          total_value: 1,
          items: [
            {
              id: "20230914001",
              google_business_vertical: "retail",
            },
          ],
        });
        fetch("https://hooks.zapier.com/hooks/catch/13962342/uplgnsv/", {
          method: "POST",
          body: JSON.stringify({
            phone: "",
            email: inputvalue,
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            console.log(data);
            if (data.status == "success") {
              this.querySelector(".newsletter__button").innerHTML = "SUCCESS";
              this.querySelector(".newsletter__input").value = "";
              alert("Success! Enjoy 10% off with code: NewCustomer10");
              setTimeout(() => {
                this.querySelector(".newsletter__button").innerHTML =
                  "SUBSCRIBE";
              }, 2000);
            } else {
              alert("Incorrect email format");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      };
    }
  }
  window.customElements.define("shopify-email-from", ShopifyEmailFrom);

  class menuNewsletterBox extends HTMLElement {
    constructor() {
      super();
      this.zapier_url = this.getAttribute("zapier-url");
      this.querySelector(".newsletter-button").onclick = () => {
        let inputvalue = this.querySelector(".newsletter-input").value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(inputvalue)) {
          alert("Incorrect email format");
          return;
        }
        fetch(this.zapier_url, {
          method: "POST",
          body: JSON.stringify({
            phone: "",
            email: inputvalue,
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            // 处理服务器响应，可能显示成功消息或错误信息
            console.log(data);
            if (data.status == "success") {
              alert("Success! You're all set to receive Gitryin email");
            } else {
              alert("Incorrect email format");
            }
          })
          .catch((error) => {
            console.log(error);
            alert("Incorrect email format");
          });
      };
    }
  }
  window.customElements.define("menu-newsletter-box", menuNewsletterBox);

  // 库存
  class ProductRemainInventory extends HTMLElement {
    constructor() {
      super();
      this.inventory_max = this.getAttribute("inventory-max-number") - 0;
      this.progress_bar = this.querySelector(".progress-bar");
      this.inventory_point = this.querySelector(".inventory-point");
      this.inventory_text = this.querySelector(".inventory-text");
      if (this.getAttribute("new-inventory")) {
        this.new_inventory = this.getAttribute("new-inventory");
        this._ChangeVariant(null);
        return;
      }
      const scriptTag = this.querySelector("script");
      this.inventories = JSON.parse(scriptTag.innerHTML);
      if (this.getAttribute("first-variant-id")) {
        this.first_variant_id = this.getAttribute("first-variant-id") - 0;
        this._ChangeVariant(this.first_variant_id);
      } else {
        this._ChangeVariant(Object.keys(this.inventories)[0]);
      }

      document.addEventListener("variant:changed", (event) => {
        let variant = event.detail.variant;
        let form = event.target;
        this._ChangeVariant(variant.id);
      });
    }
    _ChangeVariant(variant_id) {
      let inventory;
      if (variant_id == null) {
        inventory = this.new_inventory;
      } else {
        inventory = this.inventories[variant_id];
      }
      if (!inventory) {
        return;
      }
      if (inventory <= 0) {
        this.progress_bar.style.width = "100%";
        this.inventory_point.style.left = "100%";
        this.inventory_text.style.width = "100%";
        this.inventory_text.style.left = 0;
        this.inventory_text.innerHTML = `<span class="sold_out">Out of Stock<span>`;
        return;
      }

      let percentage = Math.ceil((inventory / this.inventory_max) * 100);
      if (percentage > 100) {
        percentage = 100;
        this.inventory_text.innerHTML = `<span class="Extra">Extra ${inventory} Units Availble<span>`;
        this.inventory_text.style.width = percentage + "%";
        this.inventory_text.style.left = "0%";
      } else if (percentage < 50) {
        this.inventory_text.innerHTML = `<span class="sold_out">Only ${inventory} Units Left<span>`;
        this.inventory_text.style.width = 100 - percentage + "%";
        this.inventory_text.style.left = "0%";
      } else {
        this.inventory_text.innerHTML = `<span class="Extra">Only ${inventory} Units Left<span>`;
        this.inventory_text.style.width = percentage + "%";
        this.inventory_text.style.left = 100 - percentage + "%";
      }
      this.progress_bar.style.width = 100 - percentage + "%";
      this.inventory_point.style.left = 100 - percentage + "%";
    }
  }
  window.customElements.define(
    "product-remain-inventory",
    ProductRemainInventory
  );

  class InventoryNotification extends HTMLElement {
    constructor() {
      super();
      let time_end = this.getAttribute("Countdown_time_end");
      if (time_end) {
        let time_obj = get_compare_time("2021/01/01 00:00:00", time_end);
        if (time_obj.activityType !== 1) {
          //活动未开始或已结束
          this.style.display = "none";
        } else {
          this.style.display = "flex";
        }
      }
      if (this.hasAttribute("variant-text")) {
        this.variant_text = this.getAttribute("variant-text");
        this.variants = this.variant_text.split(",");

        this.style.display = "none";
        document.addEventListener("variant:changed", (event) => {
          let variant = event.detail.variant; // Gives you access to the whole variant details
          // if(variant.sku == this.variant_text){
          //     this.style.display="flex"
          // }else{
          //     this.style.display="none"
          // }
          if (this.variants.includes(variant.sku)) {
            this.style.display = "flex";
          } else {
            this.style.display = "none";
          }
        });
        const productVariantElement =
          document.querySelector("product-variants");
        if (this.variants.includes(productVariantElement.selectedVariant.sku)) {
          this.style.display = "flex";
        }

        // if(productVariantElement.selectedVariant.sku == this.variant_text){
        //     this.style.display="flex"
        // }
      }
    }
  }
  window.customElements.define("inventory-notification", InventoryNotification);

  class Countdown_discount extends HTMLElement {
    constructor() {
      super();
      this.start_time = this.getAttribute("start_time");
      this.end_time = this.getAttribute("Countdown_time_end");
      this.now_time = this.getAttribute("now_time");

      let countdown_describe = this.getAttribute("countdown_describe");

      let now_time = Date.parse(this.now_time);
      let Countdown_time = Date.parse(this.end_time);
      let start_time = Date.parse(this.start_time);

      // 获取时间差
      let time = Countdown_time - now_time;
      // 活动未开始或已结束
      if (now_time > Countdown_time) {
        this.style.display = "none";
        return;
      }
      if (now_time < start_time) {
        this.style.display = "none";
        return;
      }
      // 活动进行中
      if (now_time < Countdown_time) {
        this.style.display = "block";
      }

      let x = setInterval(() => {
        time = time - 1000;
        let time_obj = this.get_compare_time(time);

        let daysText = time_obj.DD;
        daysText =
          daysText <= 0
            ? `<span>Today</span>`
            : `<span>${daysText}</span> Days`;

        let DownText = `${countdown_describe} in ${daysText} <span>${time_obj.HH}:${time_obj.MM}:${time_obj.SS}</span>`;
        this.querySelector(".title").innerHTML = DownText;

        if (time <= 0) {
          //活动已结束
          this.style.display = "none";
          clearInterval(x);
          return;
        }
      }, 1000);
    }
    get_compare_time(time) {
      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      let days = Math.floor(time / day);
      let hours = Math.floor((time % day) / hour);
      let minutes = Math.floor((time % hour) / minute);
      let seconds = Math.floor((time % minute) / second);

      return {
        DD: days,
        HH: hours,
        MM: minutes,
        SS: seconds,
      };
    }
  }
  window.customElements.define("countdown-discount", Countdown_discount);

  class VideoCard extends HTMLElement {
    constructor() {
      super();
      this.imgBox = this.querySelector(".img-box");
      this.videoTag = this.querySelector(".video-box video");
      this.replayTag = this.querySelector(".text-box .replay-icon");
      this.textTag = this.querySelector(".text-box");
      this.background = this.getAttribute("mask-background");
      if (!this.hasAttribute("autoplay")) {
        this.videoTag.addEventListener("ended", () => {
          this.showImg();
        });
      }
      this.replayTag.onclick = () => {
        this.replay();
      };

      window.addEventListener("scroll", this.handleScroll.bind(this));
      document.body.addEventListener("scroll", this.handleScroll.bind(this));

      this.replay_timer = false;
      this.handleScroll();
    }
    handleScroll() {
      const rect = this.getBoundingClientRect();
      if (rect.top >= -rect.height && rect.top <= window.innerHeight) {
        if (!this.replay_timer) {
          this.replay();
          this.replay_timer = true;
        }
      } else {
        this.replay_timer = false;
      }
    }
    replay() {
      this.videoTag.play();
      this.hideImg();
    }
    showImg() {
      this.imgBox.style.opacity = 1;
      this.videoTag.style.opacity = 0;
      this.replayTag.style.opacity = 1;
      this.textTag.style.background = this.background;
    }
    hideImg() {
      this.videoTag.style.opacity = 1;
      this.imgBox.style.opacity = 0;
      this.replayTag.style.opacity = 0;
      this.textTag.style.background = "transparent";
    }
  }
  window.customElements.define("video-card", VideoCard);

  // window.addEventListener("scroll", (e) => {
  //     let scroll_height=document.body.clientHeight-document.querySelector('.footer').clientHeight-document.querySelector('.header_nav_w.header').clientHeight
  //     if(document.documentElement.scrollTop>=scroll_height){
  //         document.querySelector('.header_nav_w.header').style.setProperty('--header-background','64, 72, 75')
  //     }else{
  //         document.querySelector('.header_nav_w.header').style.setProperty('--header-background','56, 63, 66')
  //     }
  // })

    class BannerCountdown extends HTMLElement {
        constructor() {
            super();
            this.start_time = this.getAttribute('start_time') || '2022/11/01 05:00:00'
            if (this.hasAttribute('now_time')) {
                this.now_time = this.getAttribute('now_time')
            }
            if (this.hasAttribute('Countdown_time')) {
                this.Countdown_time = this.getAttribute('Countdown_time')
                this.CountDownStart()
            }
        }
        CountDownStart() {
            let now_time = Date.parse(this.now_time)
            let Countdown_time = Date.parse(this.Countdown_time)
            let start_time = Date.parse(this.start_time)
            // 获取时间差
            let time = Countdown_time - now_time
            // 活动未开始或已结束
            if (now_time > Countdown_time) {
                this.style.display = 'none'
                return
            }
            if (now_time < start_time) {
                this.style.display = 'none'
                return
            }
            // 活动进行中
            if (now_time < Countdown_time) {
                this.style.display = 'flex'
            }
    
            let x = setInterval(() => {
                time = time-1000
                let time_obj = this.get_compare_time(time)
                // 修改倒计时 并且对小于十的进行补零操作
                this.querySelector("#Countdown_days").innerText = time_obj.DD < 10 ? "0" + time_obj.DD : time_obj.DD
                this.querySelector("#Countdown_hours").innerText = time_obj.HH < 10 ? "0" + time_obj.HH : time_obj.HH
                this.querySelector("#Countdown_minutes").innerText = time_obj.MM < 10 ? "0" + time_obj.MM : time_obj.MM
                this.querySelector("#Countdown_seconds").innerText = time_obj.SS < 10 ? "0" + time_obj.SS : time_obj.SS
                if (time <= 0) { //活动未开始或已结束
                    this.style.display = 'none'
                    clearInterval(x);
                    return
                }
            }, 1000)
        }
        get_compare_time(time) {
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;
            const day = hour * 24;
    
            let days = Math.floor(time / day);
            let hours = Math.floor((time % day) / hour);
            let minutes = Math.floor((time % hour) / minute);
            let seconds = Math.floor((time % minute) / second);
    
            return {
                DD: days,
                HH: hours,
                MM: minutes,
                SS: seconds
            }
        }
    }
    window.customElements.define('banner-countdown', BannerCountdown);

    class MainProductBuyXGetY extends HTMLElement {
        constructor() {
            super();
            this.left_number = this.getAttribute('left_number');
            this.right_number = this.getAttribute('right_number');
            this.left_product_handle = this.getAttribute('left_product_handle');
            this.right_product_handle = this.getAttribute('right_product_handle');
            this.left_select = this.querySelector('.buy_x_get_y_left .buy_x_get_y_product_variant_select');
            this.right_select = this.querySelector('.buy_x_get_y_right .buy_x_get_y_product_variant_select');
            this.left_variant = this.left_select.value;
            this.right_variant = this.right_select.value;
            this.addTocartType = true;
    
            this.getProduct(this.left_product_handle).then((data) => {
                if(data.available != true || this.left_select.hasAttribute("disabled")){
                    this.addTocartType = false;
                    this.left_select.selectedIndex = 0;
                    this.changeSoldOut()
                }
                this.left_product = data;
                this.left_select.addEventListener('change', ()=>{
                    this.left_variant = this.left_select.value;
                    let imgSrc = this.left_product.variants.find((variant) => variant.id == this.left_variant).featured_image.src;
                    this.querySelector(".buy_x_get_y_left .buy_x_get_y_product_img img").src = imgSrc;
                    this.querySelector(".buy_x_get_y_left .buy_x_get_y_product_img img").srcset = imgSrc;
                });
            })
            this.getProduct(this.right_product_handle).then((data) => {
                if(data.available != true || this.left_select.hasAttribute("disabled")){
                    this.addTocartType = false;
                    this.right_select.selectedIndex = 0;
                    this.changeSoldOut()
                }
                this.right_product = data;
                this.right_select.addEventListener('change', ()=>{
                    this.right_variant = this.right_select.value;
                    let imgSrc = this.right_product.variants.find((variant) => variant.id == this.right_variant).featured_image.src;
                    this.querySelector(".buy_x_get_y_right .buy_x_get_y_product_img img").src = imgSrc;
                    this.querySelector(".buy_x_get_y_right .buy_x_get_y_product_img img").srcset = imgSrc;
                })
            })
            this.querySelector('.buy_x_get_y_button').addEventListener('click', ()=>{
                if(this.addTocartType != true){
                    return
                }
                this.addToCart();
            })
        }
        changeSoldOut(){
            this.querySelector('.buy_x_get_y_button').innerText = "Sold Out";
            this.querySelector('.buy_x_get_y_button').classList.add('sold_out');
        }
        getProduct(handle) {
            return new Promise(async (resolve, reject) => {
                fetch('/products/' + handle + '.js')
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        }
        addToCart() {
            this.products = [
                {
                    id: this.left_select.value,
                    quantity: this.left_number
                },
                {
                    id: this.right_select.value,
                    quantity: this.right_number
                }
            ]
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ items: this.products })
            }).then((response) => {
                if (response.ok) {
                    // 添加成功
                    this.get_cart().then((res) => {
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                            bubbles: false,
                            detail: {
                                cart: res,
                                openMiniCart: true
                            }
                        }));
                    }).catch((err) => {
                        console.log(err);
                    })
                } else {
                    console.error('产品添加到购物车失败');
                }
            }).catch((error) => {
                console.error('加入购物车失败:', error);
            });
        }
        get_cart() {
            return new Promise((resolve, reject) => {
                // 获取购物车数据
                fetch('/cart.js')
                    .then((response) => {
                        if (response.ok) {
                            return response.json();
                        } else {
                            reject('获取购物车err')
                        }
                    })
                    .then((cartData) => {
                        resolve(cartData)
                    })
                    .catch(function (error) {
                        reject(error)
                    });
            })
        }
    }
    window.customElements.define('main-product-buyxgety', MainProductBuyXGetY);
  
  class ProductDescriptions extends HTMLElement {
    constructor() {
      super();
      let tabs = this.querySelectorAll(
        ".description__tab .description__tab_item"
      );
      let contents = this.querySelectorAll(
        ".description__content .description__content_box"
      );

      tabs.forEach((tab, index) => {
        tab.onclick = () => {
          if (tab.classList.contains("active")) {
            return;
          }
          this.removeActive(tabs);
          tab.classList.add("active");
          this.removeActive(contents);
          contents[index].classList.add("active");
        };
      });

      contents.forEach((item) => {
        let learn_more = item.querySelector(".description__learn_more");
        learn_more.onclick = () => {
          if (item.hasAttribute("open")) {
            item.removeAttribute("open");
          } else {
            item.setAttribute("open", "");
          }
        };
      });
    }
    removeActive(eles) {
      eles.forEach((ele) => {
        if (ele.classList.contains("active")) {
          ele.classList.remove("active");
        }
      });
    }
  }
  window.customElements.define("product-descriptions", ProductDescriptions);

  class DetailedInformation extends HTMLElement {
    constructor() {
      super();

      this.querySelector(".detailed_information__head").onclick = () => {
        if (this.hasAttribute("open")) {
          this.removeAttribute("open");
          if (this.querySelector(".detailed_information__body")) {
            this.select_drawer_hide();
          }
        } else {
          this.setAttribute("open", "");
          if (this.querySelector(".detailed_information__body")) {
            this.select_drawer_open();
          }
        }
        if (this.querySelector(".popup__drawer")) {
          this.drawer_open();
        }
      };
      if (this.querySelector(".detailed_information__body")) {
        if (this.hasAttribute("open")) {
          this.querySelector(".detailed_information__body").style.display =
            "block";
          this.querySelector(".detailed_information__body").style.opacity = "1";
          this.body_height = this.querySelector(
            ".detailed_information__body"
          ).offsetHeight;
          this.querySelector(".detailed_information__body").style.padding =
            "10px 0px 0px";
        } else {
          this.querySelector(".detailed_information__body").style.display =
            "block";
          this.body_height = this.querySelector(
            ".detailed_information__body"
          ).offsetHeight;
          console.log(this.body_height);
          this.querySelector(".detailed_information__body").style.height =
            "0px";
          this.querySelector(".detailed_information__body").style.padding =
            "0px 0px 0px";
        }
      }
      if (this.querySelector(".popup__drawer")) {
        this.querySelector(".popup__drawer").onclick = () => {
          if (this.hasAttribute("open")) {
            this.removeAttribute("open");
          }
          this.drawer_close();
        };
        this.querySelector(".popup__drawer_box").onclick = (event) => {
          event.stopPropagation();
        };
        this.querySelector(".drawer__head .arrow_icon").onclick = () => {
          if (this.hasAttribute("open")) {
            this.removeAttribute("open");
          }
          this.drawer_close();
        };
      }
      if (this.hasAttribute("variant")) {
        let scriptTag = this.querySelector("script");
        let json = JSON.parse(scriptTag.innerHTML);
        console.log(json);

        let variant_btns = this.querySelectorAll(".variant_btn");
        variant_btns.forEach((variant_btn) => {
          variant_btn.onclick = () => {
            if (variant_btn.classList.contains("active")) {
              return;
            }
            variant_btns.forEach((i) => {
              if (i.classList.contains("active")) {
                i.classList.remove("active");
              }
            });
            variant_btn.classList.add("active");
            json.forEach((item) => {
              console.log(
                item.variant_title == variant_btn.getAttribute("variant_title")
              );
              if (
                item.variant_title == variant_btn.getAttribute("variant_title")
              ) {
                console.log(item);
                let str = "";
                item.content.forEach((i) => {
                  str += `<div class="specifications_item">
                                                <div class="specifications_title">${i.title}</div>
                                                <div class="specifications_content">${i.content}</div>
                                            </div>`;
                });
                item.instructions.forEach((i) => {
                  str += `<div class="specifications_item">
                                                <div class="specifications_title">Product Manual</div>
                                                <div class="specifications_content"><a href="${i.url}">${i.title}</a></div>
                                            </div>`;
                });
                this.querySelector(".product_specifications").innerHTML = str;
              }
            });
          };
        });
      }
    }
    select_drawer_open() {
      this.querySelector(".detailed_information__body").animate(
        {
          height: this.body_height + "px",
          padding: "10px 0px 0px",
          opacity: "1",
        },
        {
          duration: 300,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          fill: "forwards",
        }
      );
    }
    select_drawer_hide() {
      this.body_height =
        this.querySelector(".detailed_information__body").offsetHeight + 1;
      this.querySelector(".detailed_information__body").animate(
        {
          height: "0px",
          padding: "0px 0px 0px",
          opacity: "0",
        },
        {
          duration: 300,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          fill: "forwards",
        }
      );
    }
    drawer_open() {
      this.querySelector(".popup__drawer").style.transform = "translateX(0%)";
      this.querySelector(".popup__drawer").animate(
        {
          backgroundColor: "rgba(0, 0, 0, 0.3)",
        },
        {
          duration: 450,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          fill: "forwards",
        }
      );
      this.querySelector(".popup__drawer_box").animate(
        {
          transform: "translateX(0%)",
        },
        {
          duration: 450,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          fill: "forwards",
        }
      );
    }
    drawer_close() {
      this.querySelector(".popup__drawer_box").animate(
        {
          transform: "translateX(100%)",
        },
        {
          duration: 450,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          fill: "forwards",
        }
      );
      this.querySelector(".popup__drawer").animate(
        {
          backgroundColor: "rgba(0, 0, 0, 0)",
        },
        {
          duration: 450,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          fill: "forwards",
        }
      );
      this.timer = setTimeout(() => {
        this.querySelector(".popup__drawer").style.transform =
          "translateX(100%)";
      }, 500);
    }
  }
  window.customElements.define("detailed-information", DetailedInformation);

    // 产品页猜你喜欢加折扣码倒计时复制
    class ProductDiscountCode extends HTMLElement {
        constructor() {
            super();
            this.product_id = this.getAttribute('product-id')
            this.variant_id = this.getAttribute('variant-id')
            this.show_select = this.getAttribute('show_select')
            this.now_time = this.getAttribute('now_time')
            this.start_time = this.getAttribute('start_time')
            this.end_time = this.getAttribute('end_time')
            this.change_type = true
            this.copied=false
            this.countdown_type=false
            if (this.hasAttribute('discount-code')) {
                this.discount_code = this.getAttribute('discount-code')
                this.querySelector('.copy_button').onclick = (event) => {
                    event.stopPropagation()
                    this.copy_code()
                }
                this.countdown()
            }
            if(!this.product_id){
                return;
            }

            this.init()
            if(this.show_select == 'true'){
                this.querySelector(".countdown-variant_select").onclick=(e)=>{
                    e.stopPropagation()
                }
                this.querySelector(".countdown-variant_select").addEventListener('change',(e)=>{
                    if(e.target.hasAttribute('disabled')){
                        e.target.selectedIndex = 0;
                        return;
                    }
                    this.variant_id = e.target.value;
                    this.get_in_cart()
                })
            }
        }
        get_in_cart(){
            // 判断当前变体是否在购物车里面
            // 删除成功
            this.get_cart().then((res) => {
                this.active = false
                res.items.forEach(item => {
                    if (item.product_id == this.product_id && item.variant_id == this.variant_id) {
                        this.active = true
                    }
                });
            }).catch((err) => {
                console.log(err);
            })
        }
        init() {
            this.loading()
            this.addEventListener('click',(event)=>{
                event.stopPropagation()
                if(this.change_type){
                    return
                }
                if(this.active){
                    this.remove_to_cart()
                }else{
                    this.add_to_cart()
                }                
            },false)
            // 购物车更新
            document.addEventListener('cart:updated', (event) => {
                var cart = event.detail.cart;
                let items = cart.items
                let active = false
                items.forEach(item => {
                    if (item.product_id == this.product_id && item.variant_id == this.variant_id) {
                        active = true
                    }
                });
                this.active = active
            });
        }
        loading() {
            this.get_cart().then((res) => {
                let items = res.items
                items.forEach(item => {
                    if (item.product_id == this.product_id && item.variant_id == this.variant_id) {
                        this.active = true
                    }
                })
                this.change_type = false
            }).catch((err) => {
                console.log(err);
                this.change_type = false
            })
        }
        get_cart() {
            return new Promise((resolve, reject) => {
                // 获取购物车数据
                fetch('/cart.js')
                    .then((response) => {
                        if (response.ok) {
                            return response.json();
                        } else {
                            reject('获取购物车err')
                        }
                    })
                    .then((cartData) => {
                        resolve(cartData)
                    })
                    .catch(function (error) {
                        reject(error)
                    });
            })
        }
        async cart_updata(){
          const response = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
            body: JSON.stringify({ note: this.value }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            }
          });
          const cartContent = await response.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
        }
        add_to_cart() {
            this.change_type = true
            // 发起 AJAX 请求，将产品添加到购物车
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    quantity: 1,
                    id: this.variant_id
                })
            })
                .then((response) => {
                    if (response.ok) {
                        // 添加成功
                        this.get_cart().then((res) => {
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: false,
                                detail: {
                                    cart: res,
                                    openMiniCart: false
                                }
                            }));
                            this.cart_updata()
                            this.active = true
                            this.change_type = false
                        }).catch((err) => {
                            console.log(err);
                            this.change_type = false
                        })
                    } else {
                        // 添加失败
                        console.error('产品添加到购物车失败');
                        this.change_type = false
                    }
                })
                .catch((error) => {
                    console.error('发生错误', error);
                    this.change_type = false
                });
        }
        remove_to_cart() {
            this.change_type = true
            // 发起 AJAX 请求，从购物车中删除产品
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: this.variant_id,
                    quantity: 0
                })
            })
                .then((response) => {
                    if (response.ok) {
                        // 删除成功
                        this.get_cart().then((res) => {
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: false,
                                detail: {
                                    cart: res,
                                    openMiniCart: false
                                }
                            }));
                            this.cart_updata()
                            this.active = false
                            this.change_type = false
                        }).catch((err) => {
                            console.log(err);
                            this.change_type = false
                        })
                    } else {
                        // 删除失败
                        console.error('产品从购物车中删除失败');
                        this.change_type = false
                    }
                })
                .catch((error) => {
                    console.error('发生错误', error);
                    this.change_type = false
                });
        }
        get active() {
            if (this.hasAttribute('active')) {
                return true
            } else {
                return false
            }
        }
        set active(value) {
            if (value) {
                this.setAttribute('active', '')
            } else {
                if (this.hasAttribute('active')) {
                    this.removeAttribute('active')
                }
            }
        }
        get change_type() {
            if (this.hasAttribute('loading')) {
                return true
            } else {
                return false
            }
        }
        set change_type(value) {
            if (value) {
                this.setAttribute('loading', '')
            } else {
                if (this.hasAttribute('loading')) {
                    this.removeAttribute('loading')
                }
            }
        }
        get copied(){
            if (this.hasAttribute('copied')) {
                return true
            } else {
                return false
            }
        }
        set copied(value) {
            if (value) {
                this.setAttribute('copied', '')
            } else {
                if (this.hasAttribute('copied')) {
                    this.removeAttribute('copied')
                }
            }
        }
        copy_code() {
            if (!this.active&&!!this.product_id) {
                this.add_to_cart()
            }
            if (this.copied) {
                return
            }
            const input = document.createElement('textarea');
            input.innerHTML = this.discount_code;
            console.log(input.innerHTML)
            input.setAttribute('code', 1);
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
          

            this.querySelector('.copy_button').innerHTML = 'COPIED!'
            this.copied = true
            setTimeout(() => {
                this.querySelector('.copy_button').innerHTML = 'COPY CODE'
                this.copied = false
            }, 15000)
        }
        get countdown_type(){
            if (this.hasAttribute('countdown_type')) {
                return true
            } else {
                return false
            }
        }
        set countdown_type(value) {
            if (value) {
                this.setAttribute('countdown_type', '')
                document.getElementById(this.getAttribute("block-id")).style.display = 'block'
            } else {
                if (this.hasAttribute('countdown_type')) {
                    this.removeAttribute('countdown_type')
                    document.getElementById(this.getAttribute("block-id")).style.display = 'none'
                }
            }
        }
        
        get_compare_time(time){
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;
            const day = hour * 24;
    
            let days = Math.floor(time / day);
            let hours = Math.floor((time % day) / hour);
            let minutes = Math.floor((time % hour) / minute);
            let seconds = Math.floor((time % minute) / second);
    
            return {
                DD: days,
                HH: hours,
                MM: minutes,
                SS: seconds
            }
        }
        countdown() {
            let countdown_describe = this.getAttribute('countdown_describe')

            let now_time = Date.parse(this.now_time)
            let Countdown_time = Date.parse(this.end_time)
            let start_time = Date.parse(this.start_time)

            // 获取时间差
            let time = Countdown_time - now_time
            // 活动未开始或已结束
            if (now_time > Countdown_time) {
                this.countdown_type=false
                return
            }
            if (now_time < start_time) {
                this.countdown_type=false
                return
            }
            // 活动进行中
            if (now_time < Countdown_time) {
                this.countdown_type=true
            }
    
            let x = setInterval(() => {
                time = time-1000
                let time_obj = this.get_compare_time(time)

                let daysText = time_obj.DD;
                daysText = daysText <= 0 ? `<span>Today</span>` : `<span>${daysText}</span> Days`

                let DownText = `${countdown_describe} in ${daysText} <span>${time_obj.HH}:${time_obj.MM}:${time_obj.SS}</span>`
                this.querySelector(".product-discount-code__product_detail .countdown-time").innerHTML = DownText;
                
                if (time <= 0) { //活动已结束
                    this.countdown_type=false
                    clearInterval(x);
                    return
                }
            }, 1000)
        }
    }
    window.customElements.define('product-discount-code', ProductDiscountCode);

    //产品卡片
    class BundleProductCard extends HTMLElement {
        constructor() {
            super();
            this.init();
        }
        get checked(){
            return this.hasAttribute('checked');
        }
        set checked(value){
            if(value){
                this.setAttribute('checked', '');
            }else{
                this.removeAttribute('checked');
            }
        }
        async init(){
            this.section_id = this.getAttribute('section-id');
            this.block_id = this.getAttribute('block-id');
            let handle = this.getAttribute('product-handle');
            if(!handle){
                return
            }
            this.variant_medias = null
            this.json = this.querySelector('script[type="application/json"]')
            if(this.json){
                this.variant_medias = JSON.parse(this.json.textContent);
            }

            this.product =await getProduct(handle);
            this.variant = this.product.variants[0];
            this.quantity = 1
            this.addEventListener('click',e=>{
                // 选中状态
                if (e.target.classList.contains('checked_box')) {
                    this.checked = !this.checked;
                    this.eventProductChange()
                }
                // 减少数量
                if (e.target.classList.contains('remove_1')) {
                    let input = e.target.parentElement.querySelector('input')
                    if(input.value<=0){
                        return
                    }
                    this.quantity = input.value - 1
                    input.value = this.quantity
                    if(this.quantity <= 0){
                        this.checked = false;
                    }
                    this.eventProductChange()
                }
                // 增加数量
                if (e.target.classList.contains('add_1')) {
                    let input = e.target.parentElement.querySelector('input')
                    if(input.value>=20){
                        return
                    }
                    this.quantity = input.value - 0 + 1
                    input.value = this.quantity
                    if(this.quantity >= 1){
                        this.checked = true;
                    }
                    this.eventProductChange()
                }
                // 打开产品弹窗
                if (e.target.classList.contains('product_card__img')||e.target.classList.contains('product_card__name')) {
                    this.querySelector('porduct-details-popup').show();
                }
            })

            document.addEventListener(`${this.section_id}:variant:updated`, (event) => {
                let section_id = event.detail.section_id
                let block_id = event.detail.block_id
                let product = event.detail.product
                let variant = event.detail.variant
                if(this.block_id == block_id && this.product.id == product.id){
                    this.variant = variant
                    this.eventProductChange()
                    this.render()
                }
            })
            document.addEventListener(`${this.section_id}:section:loading`, (event) => {
                this.eventProductChange()
            })
        }
        eventProductChange(){
            document.documentElement.dispatchEvent(new CustomEvent(`${this.section_id}:product:updated`, {
                bubbles: true,
                detail: {
                    product: this.product,
                    variant: this.variant,
                    quantity:this.quantity,
                    checked:this.checked,
                    section_id: this.section_id
                }
            }));
        }
        render(){
            // 更新价钱
            let price_str = formatMoney(this.variant.price);
            let compare_at_price_str = '';
            let save_tag_str = '';
            if(this.variant.compare_at_price && this.variant.compare_at_price > this.variant.price){
                compare_at_price_str = formatMoney(this.variant.compare_at_price)
                save_tag_str = `SAVE ${Math.floor((this.variant.compare_at_price-this.variant.price)/this.variant.compare_at_price * 100)}%`;
                this.querySelector(".product_card__media .save_tag").style.display = 'flex';
            }else{
                this.querySelector(".product_card__media .save_tag").style.display = 'none';
            }
            this.querySelector(".product_card__price_box .price--highlight").innerHTML = price_str;
            this.querySelector(".product_card__price_box .price--compare").innerHTML = compare_at_price_str;
            this.querySelector(".product_card__media .save_tag").innerHTML = save_tag_str;

            // 更新图片链接
            if(this.variant_medias){
                // 获取当前select选中的下标
                let index = this.querySelector(".variant-select select").selectedIndex;

                if(this.variant_medias[index]){
                    this.querySelector(".product_card__img").src = this.variant_medias[index];
                }else{
                    this.querySelector(".product_card__img").src = this.variant.featured_image.src;
                }
            }else{
                this.querySelector(".product_card__img").src = this.variant.featured_image.src;
            }
        }
    }
    customElements.define('bundle-product-card', BundleProductCard); 

  // 产品页面左侧图片部分
    class MainProductMedia extends HTMLElement {
        constructor() {
            super();
            let handle = this.getAttribute('product-handle')
            this.tags = this.getAttribute('alt-tags').split(',')
            this.swipers = [] 
            this.querySelectorAll('.media—box .media-swiper').forEach((swiper,swiperindex)=>{
                let preview_swiperitem = new Swiper(this.querySelectorAll('.preview-media-swiper')[swiperindex], {
                    slidesPerView:5,
                    watchSlidesProgress : true,
                    watchSlidesVisibility : true,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    breakpoints:{ 
                    350:{
                      slidesPerView: 5,
                    },
                    750:{
                      slidesPerView: 7.5,
                    },
                    999:{
                      slidesPerView: 7.2,
                    }
                },
                })
                let swiperitem = new Swiper(swiper, {
                    slidesPerView: 1,
                    spaceBetween : 5,
                    // watchSlidesVisibility: true,
                    thumbs: {
                        swiper: preview_swiperitem,
                        autoScrollOffset: 2,
                        centeredSlides: true,
                        centeredSlidesBounds: true,
                    }
                })
                this.swipers.push(swiperitem)
            })
            this.querySelectorAll(".media-change-buttons button").forEach((button,index)=>{
                button.addEventListener("click",()=>{
                    this.chnageSwiper(index,0)
                })
            })
            // 监听变体更新
            document.addEventListener('variant:changed', (event)=>{
                let variant = event.detail.variant;
                let form = event.target;
                if(variant.featured_media){
                    let slide = this.querySelector(`.preview-media-swiper .swiper-slide[variant-id="${variant.featured_media.id}"]`)
                    if(!slide){
                        return
                    }
                    let tag = slide.getAttribute('alt-tag')
                    // 检测this.tags里面当前tag的下标
                    let swiperindex = this.tags.indexOf(tag)
                    let slideindex = slide.getAttribute('data-index')-0
                    this.chnageSwiper(swiperindex,slideindex)
                }
            });
            // 鼠标位置检测 根据鼠标在swiper上的位置来控制显示左右箭头
            // cursor: var(--arrow-right-svg-url) 17 14,e-resize;
            // cursor: var(--arrow-left-svg-url) 17 14,w-resize;
            this.querySelectorAll('.media-swiper').forEach((swiper,swiperindex)=>{
                swiper.addEventListener('mousemove',(event)=>{
                    // 计算鼠标在swiper上的位置 在左半部分变化鼠标为左箭头 在右半部分变化鼠标为右箭头
                    let x = event.clientX - swiper.getBoundingClientRect().left
                    if(x > swiper.offsetWidth/2){
                        swiper.style.cursor = "var(--arrow-right-svg-url) 17 14,e-resize"
                    }else{
                        swiper.style.cursor = "var(--arrow-left-svg-url) 17 14,w-resize"
                    }
                })
                swiper.addEventListener("click",(event)=>{
                    let x = event.clientX - swiper.getBoundingClientRect().left
                    if(x > swiper.offsetWidth/2){
                        this.swipers[swiperindex].slideNext()
                    }else{
                        this.swipers[swiperindex].slidePrev()
                    }
                })
            })
        }
        chnageSwiper(swiperindex,slideindex){
            this.querySelectorAll('.media—box').forEach((swiper)=>{
                swiper.classList.remove("active")
            })
            this.querySelectorAll('.media—box')[swiperindex].classList.add("active")
            
            this.querySelectorAll(".media-change-buttons button").forEach((item)=>{
                item.classList.remove("active")
            })
            this.querySelectorAll(".media-change-buttons button")[swiperindex].classList.add("active")
           
            this.swipers[swiperindex].slideTo(slideindex)
        }
    }
    window.customElements.define('main-product-media', MainProductMedia);

    // 产品页折扣卡片倒计时部分
    class ProductGiftCard extends HTMLElement {
        constructor() {
            super();
            this.now_time = this.getAttribute('now_time')
            this.start_time = this.getAttribute('start_time')
            this.end_time = this.getAttribute('end_time')
    
            let now_time = Date.parse(this.now_time)
            let Countdown_time = Date.parse(this.end_time)
            let start_time = Date.parse(this.start_time)
    
            // 获取时间差
            let time = Countdown_time - now_time
            // 活动未开始或已结束
            if (now_time > Countdown_time) {
                this.style.display="none"
                return
            }
            if (now_time < start_time) {
                this.style.display="none"
                return
            }
            // 活动进行中
            if (now_time < Countdown_time) {
                this.style.display="flex"
            }
            let x = setInterval(() => {
                if (time <= 0) { //活动已结束
                    this.style.display="none"
                    clearInterval(x);
                    return
                }
            }, 1000)
        }
    }
    window.customElements.define('product-gift-card', ProductGiftCard);

  // class SwiperImgCard extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.init();
  //   }
  //   init() {
  //     new Swiper(this.querySelector(".swiper_img_card__list"), {
  //       slidesPerView: 1.3,
  //       spaceBetween: 12,
  //       breakpoints: {
  //         400: {
  //           slidesPerView: "auto",
  //           spaceBetween: 12,
  //         },
  //         500: {
  //           slidesPerView: "auto",
  //           spaceBetween: 12,
  //         },
  //         750: {
  //           slidesPerView: "auto",
  //           spaceBetween: 12,
  //         },
  //         1000: {
  //           slidesPerView: "auto",
  //           spaceBetween: 20,
  //         },
  //       },
  //       pagination: {
  //         el: this.querySelector(".swiper-pagination"),
  //         type: "progressbar",
  //       },
  //       navigation: {
  //         nextEl: this.querySelector(".next"),
  //         prevEl: this.querySelector(".prev"),
  //       },
  //     });
  //   }
  // }
  // window.customElements.define("swiper-img-card", SwiperImgCard);
})();

function link2page(link) {
  window.location.href = link;
}
function getLocalTime(i) {
  if (typeof i !== "number") return;
  var d = new Date();
  //得到1970年一月一日到现在的秒数
  var len = d.getTime();
  //本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
  var offset = d.getTimezoneOffset() * 60000;
  //得到现在的格林尼治时间
  var utcTime = len + offset;
  return new Date(utcTime + 3600000 * i);
}
function get_compare_time(beginTime, endTime) {
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  // 获取倒计时开始时间的时间戳（需要传入世界协调时）
  const countStart = Date.parse(beginTime);
  // 获取倒计时结束时间的时间戳（需要传入世界协调时）
  const countEnd = Date.parse(endTime);
  // 获取当前时间的时间戳 （世界协调时）
  const now = getLocalTime(0).getTime();
  //现在距离活动开始或结束时间的时间
  let startDistance = countStart - now;
  let endDistance = countEnd - now;
  /*
        @ nowType:
        0: "活动开始前"
        1: "活动进行中"
        2: "活动已结束"
    */

  let activityType = 0;
  let days, hours, minutes, seconds;

  if (startDistance < 0 && endDistance > 0) {
    // 活动进行中
    activityType = 1;
    days = -Math.floor(endDistance / day);
    hours = -Math.floor((endDistance % day) / hour);
    minutes = -Math.floor((endDistance % hour) / minute);
    seconds = -Math.floor((endDistance % minute) / second);
  } else if (endDistance <= 0 && startDistance < 0) {
    // 活动结束
    activityType = 2;
  } else {
    // 活动未开始
    activityType = 0;
    days = -Math.floor(startDistance / day);
    hours = -Math.floor((startDistance % day) / hour);
    minutes = -Math.floor((startDistance % hour) / minute);
    seconds = -Math.floor((startDistance % minute) / second);
  }

  return {
    activityType,
    startDistance,
    endDistance,
    DD: -days,
    HH: -hours,
    MM: -minutes,
    SS: -seconds,
  };
}
function Copy_Code_Btn_click(e, code) {
  if (e.target.innerHTML != "COPY") {
    return;
  }
  const input = document.createElement("textarea");
  document.body.appendChild(input);
  input.innerHTML = code;
  input.setAttribute("code", 1);
  input.select();
  document.execCommand("copy");

  var list = document.getElementsByTagName("textarea");
  var inputList = Array.prototype.slice.call(list);
  inputList.forEach((item) => {
    if (item.getAttribute("code")) document.body.removeChild(item);
  });

  e.target.innerHTML = "COPIED";
  setTimeout(() => {
    e.target.innerHTML = "COPY";
  }, 2000);
}
